import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Slider from "react-slick";

export default function PricingBlock(props) {
  // BONUS
  const prevBonus = () => {
    bonusRef.current.slickPrev();
  };
  const nextBonus = () => {
    bonusRef.current.slickNext();
  };

  const bonusSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
  };

  const bonusRef = useRef();
  return (
    <>
      <section className="pricing_section">
        <div className="container">
          <Slider ref={bonusRef} {...bonusSettings}>
            <div className="slick_item">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="pricing_heading">
                    Advantages of the Platinum &
                  </div>
                  <div className="pricing_heading padding_bottom_15">
                    Diamond VIP program.
                  </div>

                  <div className="paragraph padding_bottom_15">
                    Joker Casino handsomely rewards loyal players with an
                    excellent loyalty coin program.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    With every $20 you play in cash bets on slots, you will
                    receive 1 loyalty coin. With those coins, you can go to the
                    loyalty coin shop and buy cool items like free spins, bonus
                    money, and even cash.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    Joker Casino also has a great VIP member program. The more
                    money you have deposited in total, the higher your VIP level
                    will be. The higher your VIP level, the faster you will earn
                    Loyalty Coins thanks to the Loyalty Coin Accelerator. See
                    all the details on our Bonus <Link to="#">Terms page.</Link>
                  </div>
                  <div className={"title_colored " + props.landingType}>
                    Companies that trust us.
                  </div>
                  <div className="brands">
                    <ul>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/mastercard.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/bank-transfer.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/paysafe.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/skrill.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/neteler.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/verified-visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/gamstop.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/evoletion.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="slick_item">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="pricing_heading">
                    Advantages of the Platinum &
                  </div>
                  <div className="pricing_heading padding_bottom_15">
                    Diamond VIP program.
                  </div>

                  <div className="paragraph padding_bottom_15">
                    Joker Casino handsomely rewards loyal players with an
                    excellent loyalty coin program.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    With every $20 you play in cash bets on slots, you will
                    receive 1 loyalty coin. With those coins, you can go to the
                    loyalty coin shop and buy cool items like free spins, bonus
                    money, and even cash.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    Joker Casino also has a great VIP member program. The more
                    money you have deposited in total, the higher your VIP level
                    will be. The higher your VIP level, the faster you will earn
                    Loyalty Coins thanks to the Loyalty Coin Accelerator. See
                    all the details on our Bonus <Link to="#">Terms page.</Link>
                  </div>
                  <div className={"title_colored " + props.landingType}>
                    Companies that trust us.
                  </div>
                  <div className="brands">
                    <ul>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/mastercard.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/bank-transfer.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/paysafe.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/skrill.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/neteler.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/verified-visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/gamstop.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/evoletion.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="slick_item">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="pricing_heading">
                    Advantages of the Platinum &
                  </div>
                  <div className="pricing_heading padding_bottom_15">
                    Diamond VIP program.
                  </div>

                  <div className="paragraph padding_bottom_15">
                    Joker Casino handsomely rewards loyal players with an
                    excellent loyalty coin program.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    With every $20 you play in cash bets on slots, you will
                    receive 1 loyalty coin. With those coins, you can go to the
                    loyalty coin shop and buy cool items like free spins, bonus
                    money, and even cash.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    Joker Casino also has a great VIP member program. The more
                    money you have deposited in total, the higher your VIP level
                    will be. The higher your VIP level, the faster you will earn
                    Loyalty Coins thanks to the Loyalty Coin Accelerator. See
                    all the details on our Bonus <Link to="#">Terms page.</Link>
                  </div>
                  <div className={"title_colored " + props.landingType}>
                    Companies that trust us.
                  </div>
                  <div className="brands">
                    <ul>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/mastercard.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/bank-transfer.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/paysafe.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/skrill.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/neteler.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/verified-visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/gamstop.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/evoletion.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="slick_item">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="pricing_heading">
                    Advantages of the Platinum &
                  </div>
                  <div className="pricing_heading padding_bottom_15">
                    Diamond VIP program.
                  </div>

                  <div className="paragraph padding_bottom_15">
                    Joker Casino handsomely rewards loyal players with an
                    excellent loyalty coin program.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    With every $20 you play in cash bets on slots, you will
                    receive 1 loyalty coin. With those coins, you can go to the
                    loyalty coin shop and buy cool items like free spins, bonus
                    money, and even cash.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    Joker Casino also has a great VIP member program. The more
                    money you have deposited in total, the higher your VIP level
                    will be. The higher your VIP level, the faster you will earn
                    Loyalty Coins thanks to the Loyalty Coin Accelerator. See
                    all the details on our Bonus <Link to="#">Terms page.</Link>
                  </div>
                  <div className={"title_colored " + props.landingType}>
                    Companies that trust us.
                  </div>
                  <div className="brands">
                    <ul>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/mastercard.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/bank-transfer.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/paysafe.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/skrill.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/neteler.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/verified-visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/gamstop.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/evoletion.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="slick_item">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="pricing_heading">
                    Advantages of the Platinum &
                  </div>
                  <div className="pricing_heading padding_bottom_15">
                    Diamond VIP program.
                  </div>

                  <div className="paragraph padding_bottom_15">
                    Joker Casino handsomely rewards loyal players with an
                    excellent loyalty coin program.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    With every $20 you play in cash bets on slots, you will
                    receive 1 loyalty coin. With those coins, you can go to the
                    loyalty coin shop and buy cool items like free spins, bonus
                    money, and even cash.
                  </div>
                  <div className="paragraph padding_bottom_15">
                    Joker Casino also has a great VIP member program. The more
                    money you have deposited in total, the higher your VIP level
                    will be. The higher your VIP level, the faster you will earn
                    Loyalty Coins thanks to the Loyalty Coin Accelerator. See
                    all the details on our Bonus <Link to="#">Terms page.</Link>
                  </div>
                  <div className={"title_colored " + props.landingType}>
                    Companies that trust us.
                  </div>
                  <div className="brands">
                    <ul>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/mastercard.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/bank-transfer.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/paysafe.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/skrill.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/neteler.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/verified-visa.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/gamstop.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <img
                            src={
                              require("../assets/images/new-landing/brands/evoletion.png")
                                .default
                            }
                            alt="game image"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-3">
                  <div className="single_price_block">
                    <div className="badge">Popular</div>
                    <div className="plan_name">Platinum Level</div>
                    <div className="paragraph">
                      Lorem ipsum dolor sit amet, consectetur cing elit, sed do
                      eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit, sed do eiusmod tempor, consectetur
                      adipiscing elit.
                    </div>
                    <div className="features">
                      <ul>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                        <li>
                          <span className={"icon " + props.landingType}>
                            <i class="fas fa-check"></i>
                          </span>
                          Lorem Ipsum dolor sit amet
                        </li>
                      </ul>
                    </div>
                    <div className="price_bottom">
                      <div className="text_area">
                        <div className="plan_title">Relevant information</div>
                        <div className="plan_title">231.212</div>
                      </div>
                      <div className="join_area">
                        <Link
                          className={"gameplay_btn " + props.landingType}
                          to="#"
                        >
                          Join Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>
      <br />
      <div className="slider_prev_next">
        <button onClick={prevBonus} className="action_btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="20"
            fill="white"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            />
          </svg>
          Prev
        </button>
        <button onClick={nextBonus} className="action_btn">
          Next
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="20"
            fill="white"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
